import { useQuery } from "@tanstack/react-query";

import { MS_PER_MINUTE } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { CallHistoryResponse, HttpResponse } from "@/types";

const CALL_HISTORY_STALE_TIME_MS = 5 * MS_PER_MINUTE;

export const callHistoryQueryKey = (talentId: number) => {
  return ["call-history", talentId] as const;
};

export const useGetCallHistory = (talentId: number) => {
  return useQuery({
    enabled: talentId > 0,
    staleTime: CALL_HISTORY_STALE_TIME_MS,
    queryKey: callHistoryQueryKey(talentId),
    queryFn: async () => {
      const res = await guacHttpClient.get<
        CallHistoryResponse,
        HttpResponse<CallHistoryResponse>
      >(`search/call-history?talentId=${String(talentId)}`);
      return res.data;
    },
  });
};
